import React from "react";
import { Flex, Typography, Form } from "antd";
import CloseCircleIcon from "../../../../../../../../Theme/CustomIcons/Icons/Essetional/CloseCircleIcon";
import TickCircleIcon from "../../../../../../../../Theme/CustomIcons/Icons/Arrow/TickCircleIcon";

const { Text } = Typography;

const PasswordRequirements = () => {
  const password = Form.useWatch("password");

  const requirements = [
    {
      label: "At least 12 characters long",
      check: (pwd) => pwd && pwd.length >= 12,
    },
    {
      label: "Includes uppercase letters",
      check: (pwd) => pwd && /[A-Z]/.test(pwd),
    },
    {
      label: "Includes lowercase letters",
      check: (pwd) => pwd && /[a-z]/.test(pwd),
    },
    { label: "Includes numbers", check: (pwd) => pwd && /[0-9]/.test(pwd) },
    {
      label: "Includes special characters (e.g., !@#$%)",
      check: (pwd) => pwd && /[!@#$%^&*(),.?\":{}|<>]/.test(pwd),
    },
  ];

  return (
    <Flex vertical gap={6} style={{ marginTop: 4 }}>
      <Text
        style={{
          fontWeight: 500,
          fontSize: 13,
        }}>
        Requirements:
      </Text>

      {requirements.map((req, index) => {
        const isValid = req.check(password);

        return (
          <Flex align="center" gap={6} key={index}>
            {isValid ? (
              <TickCircleIcon size="small" style={{ color: "#52c41a" }} />
            ) : (
              <CloseCircleIcon size="small" style={{ color: "#ff4d4f" }} />
            )}

            <Text
              style={{
                fontSize: 11,
                fontWeight: 400,
              }}>
              {req.label}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
};

export default PasswordRequirements;
